import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JsonLd from "@/components/base/JsonLd";
import { SITE_URL } from "@/lib/seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import InfoSections from "./components/InfoSections";
import PillarArticles from "./components/PillarArticles";

export default function Home() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace("#", "");
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [location.hash, location.pathname]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "USFansSheet",
          url: `${SITE_URL}/`,
          description:
            "Explore USFans Spreadsheet guides, product research, seller information, QC tips, shipping resources, comparisons and safety guidance.",
          inLanguage: "en",
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "USFansSheet",
          url: `${SITE_URL}/`,
          logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg",
        }}
      />
      <SiteHeader />
      <main>
        <Hero />
        <CategorySection />
        <PillarArticles />
        <InfoSections />

        {/* Main website CTA */}
        <section className="bg-primary-950 py-16 md:py-24">
          <div className="mx-auto max-w-3xl px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">
              {t("cta.title")}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm md:text-base text-background-100/80">
              {t("cta.text")}
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-sm font-semibold text-primary-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                {t("buttons.usfansSpreadsheet")}
                <i className="ri-arrow-right-up-line text-base"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex w-full sm:w-auto items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-sm font-semibold text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
              >
                {t("buttons.buyNow")}
                <i className="ri-external-link-line text-base"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}